import { z } from 'zod';

const slugRegex = /^[a-z0-9-]+$/;

export const knowledgebaseCreateSchema = z
  .object({
    title: z
      .string()
      .trim()
      .min(3, 'Title must be at least 3 characters')
      .max(200, 'Title must be 200 characters or fewer'),
    slug: z
      .string()
      .trim()
      .min(3, 'Slug must be at least 3 characters')
      .max(80, 'Slug must be 80 characters or fewer')
      .regex(slugRegex, 'Slug may only contain lowercase letters, numbers, and hyphens'),
    body: z.string().min(1, 'Body is required'),
    tags: z.array(z.string().trim().min(1)).default([]),
  })
  .strict();
export type KnowledgebaseCreateInput = z.infer<typeof knowledgebaseCreateSchema>;

export const knowledgebaseUpdateSchema = knowledgebaseCreateSchema
  .partial()
  .extend({
    isArchived: z.boolean().optional(),
  })
  .strict();
export type KnowledgebaseUpdateInput = z.infer<typeof knowledgebaseUpdateSchema>;

export const knowledgebaseSummarySchema = z.object({
  id: z.string(),
  title: z.string(),
  slug: z.string(),
  body: z.string(),
  tags: z.array(z.string()),
  isArchived: z.boolean(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});
export type KnowledgebaseSummary = z.infer<typeof knowledgebaseSummarySchema>;
